type PatientId = number;
type PrintTemplateId = number;

export const getConsentTemplateToken = (patientId: PatientId, printTemplateId: PrintTemplateId): string =>
   `visit-patient-${patientId}-consentTemplate-${printTemplateId}`;
